// extracted by mini-css-extract-plugin
module.exports = {"totalCash":"TotalCashTitle_totalCash__l7Fne"};